"use client";

import { c as _c } from "react/compiler-runtime";
import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import MemesQuickVoteAmountButton from "./MemesQuickVoteAmountButton";
type VoteFeedbackSource = "custom-submit" | "quick-amount";
const CUSTOM_AMOUNT_CONTROL_LABEL = "Change vote amount";
interface MemesQuickVoteQuickAmountsRowProps {
  readonly feedbackAmount: number | null;
  readonly feedbackSource: VoteFeedbackSource | null;
  readonly isSubmitting: boolean;
  readonly isVoteFeedbackActive: boolean;
  readonly latestUsedAmount: number | null;
  readonly onOpenCustom: () => void;
  readonly onVoteAmount: (amount: number) => void;
  readonly quickAmounts: readonly number[];
}
export default function MemesQuickVoteQuickAmountsRow(t0) {
  const $ = _c(26);
  const {
    feedbackAmount,
    feedbackSource,
    isSubmitting,
    isVoteFeedbackActive,
    latestUsedAmount,
    onOpenCustom,
    onVoteAmount,
    quickAmounts
  } = t0;
  let t1;
  if ($[0] !== feedbackAmount || $[1] !== feedbackSource || $[2] !== isSubmitting || $[3] !== isVoteFeedbackActive || $[4] !== latestUsedAmount || $[5] !== onVoteAmount || $[6] !== quickAmounts) {
    let t2;
    if ($[8] !== feedbackAmount || $[9] !== feedbackSource || $[10] !== isSubmitting || $[11] !== isVoteFeedbackActive || $[12] !== latestUsedAmount || $[13] !== onVoteAmount) {
      t2 = amount => <MemesQuickVoteAmountButton key={amount} amount={amount} feedbackAmount={feedbackAmount} feedbackSource={feedbackSource} isLatestUsed={latestUsedAmount === amount} isSubmitting={isSubmitting} isVoteFeedbackActive={isVoteFeedbackActive} onVoteAmount={onVoteAmount} />;
      $[8] = feedbackAmount;
      $[9] = feedbackSource;
      $[10] = isSubmitting;
      $[11] = isVoteFeedbackActive;
      $[12] = latestUsedAmount;
      $[13] = onVoteAmount;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    t1 = quickAmounts.map(t2);
    $[0] = feedbackAmount;
    $[1] = feedbackSource;
    $[2] = isSubmitting;
    $[3] = isVoteFeedbackActive;
    $[4] = latestUsedAmount;
    $[5] = onVoteAmount;
    $[6] = quickAmounts;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const t2 = isVoteFeedbackActive && "tw-opacity-40";
  let t3;
  if ($[15] !== t2) {
    t3 = clsx("sm:tw:flex-[1.4] sm:tw:min-w-[9.5rem] sm:tw:px-4 lg:tw:min-w-14 lg:tw:flex-none tw-relative tw-inline-flex tw-h-full tw-min-w-14 tw-flex-none tw-items-center tw-justify-center tw-gap-1 tw-rounded-xl tw-border tw-border-solid tw-border-white/5 tw-bg-white/[0.03] tw-px-3 tw-text-center tw-text-zinc-400 tw-shadow-sm tw-transition-all active:tw-scale-95 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-bg-white/[0.08] desktop-hover:hover:tw-text-white sm:tw-gap-1.5", t2);
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  let t5;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <AdjustmentsHorizontalIcon className="tw-size-4 tw-flex-shrink-0" />;
    t5 = <span className="sm:tw:text-[13px] tw-whitespace-nowrap tw-text-[12px] tw-font-bold tw-tracking-tight">{CUSTOM_AMOUNT_CONTROL_LABEL}</span>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t4 = $[17];
    t5 = $[18];
  }
  let t6;
  if ($[19] !== isSubmitting || $[20] !== onOpenCustom || $[21] !== t3) {
    t6 = <button type="button" aria-label={CUSTOM_AMOUNT_CONTROL_LABEL} onClick={onOpenCustom} disabled={isSubmitting} className={t3}>{t4}{t5}</button>;
    $[19] = isSubmitting;
    $[20] = onOpenCustom;
    $[21] = t3;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t1 || $[24] !== t6) {
    t7 = <div className="tw-flex tw-h-11 tw-w-full tw-items-stretch tw-gap-1.5 tw-overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] sm:tw-h-12 sm:tw-gap-2 md:tw-h-12 [&::-webkit-scrollbar]:tw-hidden">{t1}{t6}</div>;
    $[23] = t1;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
}